<template lang="pug">
section.popup
  .popup__overlay
  .popup__view
    .popup__body.popup__body_login
      .popup__close(@click="close")
        svg(xmlns="http://www.w3.org/2000/svg", fill="none", viewBox="0 0 330 329")
          defs
          path(fill="#F44336" fill-rule="evenodd" :d="d" clip-rule="evenodd")
      .popup__header
        slot(name="title")
          span Действие
      .popup__main.code-wrapper
        .input.input__phone
          input(v-model="code", type="text", :placeholder="placeholder")
      .popup__message
        slot(name="helper")
      .popup__footer.text-center
        .row
          button.button.button_primary(@click="activate")
            slot(name="button")
              span Выполнить
</template>

<script>
export default {
  name: 'InputDialog',
  props: {
    placeholder: {
      type: String,
      required: false,
      default: 'Введите текст',
    },
  },
  data: () => ({
    code: '',
    // eslint-disable-next-line max-len
    d: 'M299.77 327.78a21.25 21.25 0 008.16 1.62v.01a21.2 21.2 0 0015.09-6.25 21.31 21.31 0 000-30.16L194.8 164.77 323 36.56a21.31 21.31 0 00-23.24-34.79 21.31 21.31 0 00-6.92 4.63L164.63 134.61 36.42 6.39a21.31 21.31 0 00-34.8 6.92 21.3 21.3 0 004.63 23.24l128.22 128.22L6.26 292.98a21.3 21.3 0 0015.08 36.42 21.22 21.22 0 0015.08-6.25l128.21-128.21 128.22 128.21a21.27 21.27 0 006.92 4.63z',
  }),
  methods: {
    activate() {
      this.$emit('submit', this.code);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.code-wrapper{
  min-width: 280px;
  margin: 20px 0;
}
.popup__message {
  color: grey;
  font-size: 14 / 16 + rem;
  // line-height: 25 / 16 + rem;
  padding: 0 0 1.5rem 0;
}
.popup__close {
  display: block;
  width: 14 / 16 + rem;
  height: 14 / 16 + rem;
}
</style>
